import React from 'react';
import { createRoot } from 'react-dom/client';

import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';

import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import './index.css';
import App from './App';
import { ContextProvider } from './contexts/ContextProvider';

const queryClient = new QueryClient();

const domNode = document.getElementById('root');
const root = createRoot(domNode);

root.render(
    <QueryClientProvider client={queryClient}>
        <ContextProvider>
            <App />
            <ReactQueryDevtools initialIsOpen={false} />
        </ContextProvider>
    </QueryClientProvider>);